import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { useNavigate } from "react-router-dom";

const DataContext = createContext();

const apiUrl = process.env.REACT_APP_API_URL;


export const DataProvider = ({ children }) => {

    const navigate = useNavigate();

    const [token, setToken] = useState('');
    const [surveys, setSurveys] = useState(null);
    const [message, setMessage] = useState('');

    const handleClose = (
        event,
        reason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }

        setMessage('');
    };

    const checkToken = useCallback(async () => {
        if (!token) {
            const tokenTemp = localStorage.getItem('authToken');

            if (!tokenTemp) {
                navigate("/login");
                return false;
            }
            setToken(tokenTemp);
        }
        return true;
    }, [navigate, token]);

    useEffect(() => {
        checkToken();
    }, [checkToken]);

    const checkErrorStatus = useCallback((response) => {
        if (response.status === 401) {
            setToken('');
            localStorage.removeItem('authToken');
            navigate("/login");
            return;
        }
    }, [navigate]);

    const login = useCallback(async (email, password) => {
        try {
            const response = await fetch(`${apiUrl}/api/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });
            const res = await createResponse(response);

            if (response.ok) {
                const tokenTemp = res.datauser.token;
                localStorage.setItem('authToken', tokenTemp);
                navigate('/');
                return res;
            }
            return res;
        } catch (err) {
            console.log(err.message);
        }
    }, [navigate]);

    const logout = useCallback(() => {
        localStorage.removeItem('authToken');
        navigate('/');
    }, [navigate]);

    const getSurveyList = useCallback(async () => {
        if (token) {
            try {
                const response = await fetch(
                    `${apiUrl}/api/questions/survey?perpage=10000`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                    });
                const res = await createResponse(response);
                if (!response.ok) {
                    checkErrorStatus(response);
                    setSurveys([]);
                    return res;
                }
                setSurveys(res.data);
                return res;
            } catch (err) {
                console.log(err.message);
            }
        }
    }, [checkErrorStatus, token])

    const getSurveyDetail = useCallback(async (id) => {
        if (token) {
            try {
                const response = await fetch(
                    `${apiUrl}/api/questions/survey/detail/${id}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                    });
                const res = await createResponse(response);
                if (!response.ok) {
                    checkErrorStatus(response);
                    return res;
                }
                return res;
            } catch (err) {
                console.log(err.message);
            }
        }
    }, [checkErrorStatus, token])

    const postResult = useCallback(async (data) => {
        if (token) {
            try {
                const response = await fetch(
                    `${apiUrl}/api/voter/add`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify(data),

                    });
                const res = await createResponse(response);
                if (!response.ok) {
                    checkErrorStatus(response);
                    return res;
                }
                return res;
            } catch (err) {
                console.log(err.message);
            }
        }
    }, [checkErrorStatus, token])

    async function createResponse(response) {
        const responseData = await response.json();

        let msgTemp = ''
        if (response.status !== 200) {
            if (responseData?.respon?.pesan)
                msgTemp = responseData?.respon?.pesan;
            else if (responseData?.message)
                msgTemp = responseData?.message;
            else
                msgTemp = response.statusText;
        }
        setMessage(msgTemp);

        return {
            ...responseData,
            success: response.ok,
            status: response.status,
            text: response.statusText,
        }
    }

    const values = {
        surveys,
        postResult,
        getSurveyList,
        getSurveyDetail,
        checkErrorStatus,
        checkToken,
        login,
        logout,
        setMessage,
    }

    return (
        <DataContext.Provider value={{ ...values }}>
            {children}
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={message !== ''}
                autoHideDuration={5000}
                onClose={handleClose}
                message={message}
            />
        </DataContext.Provider>
    );
};


export function useData() {
    return useContext(DataContext);
}



